import { api } from './client'

// ASYS for accountants (backend api/practice.py). A practice signs up free;
// companies invite it from Settings → Accountant; its staff open their
// clients' books from the Clients list.

export const practiceSignup = async (payload) => {
  const { data } = await api.post('/practice/signup', payload)
  try {
    if (data?.user_id) localStorage.setItem('actorId', String(data.user_id))
    if (data?.username) localStorage.setItem('actorName', data.full_name || data.username)
    if (data?.user_id) localStorage.setItem('asysLastActivityAt', String(Date.now()))
  } catch {}
  return data
}
export const listClients = async () => (await api.get('/practice/clients')).data
export const clientFigures = async (clientId) => (await api.get(`/practice/clients/${clientId}/figures`)).data
export const addClient = async (payload) => (await api.post('/practice/clients', payload)).data
export const emailOwnerAgain = async (clientId) => (await api.post(`/practice/clients/${clientId}/owner-email`)).data
export const dropClient = async (clientId) => (await api.delete(`/practice/clients/${clientId}`)).data
export const openClient = async (clientId) => (await api.post(`/practice/clients/${clientId}/open`)).data
export const backToPractice = async () => (await api.post('/practice/return')).data
export const getInvite = async (token) => (await api.get(`/practice/invites/${encodeURIComponent(token)}`)).data
export const acceptInvite = async (token) => (await api.post(`/practice/invites/${encodeURIComponent(token)}/accept`)).data

// The practice's people (admins only), and the clients each can open.
export const listStaff = async () => (await api.get('/practice/staff')).data
export const addStaff = async (payload) => (await api.post('/practice/staff', payload)).data
export const updateStaff = async (userId, payload) => (await api.put(`/practice/staff/${userId}`, payload)).data
export const staffLinkAgain = async (userId) => (await api.post(`/practice/staff/${userId}/link`)).data

// The company's side: its accountants.
export const listAccountants = async () => (await api.get('/settings/accountants')).data
export const inviteAccountant = async ({ email, access }) => (await api.post('/settings/accountants', { email, access })).data
export const changeAccountantAccess = async (linkId, access) => (await api.put(`/settings/accountants/${linkId}`, { access })).data
export const removeAccountant = async (linkId) => (await api.delete(`/settings/accountants/${linkId}`)).data
